import type { AxiosResponse } from 'axios';
import { axiosInstance } from '@/services/axios.service';
import { ENDPOINTS } from '@/constants/endpoints';

export interface GoogleOAuthUrlResponse {
	GoogleOAuthUrl: string;
	RedirectUrl: string;
}

export interface CheckGoogleUserRequest {
	AccessToken: string;
}

export interface CheckGoogleUserResponse {
	GoogleKey: string;
	FirstName: string;
	LastName: string;
	Email: string;
	Phone?: string;
	ExistingUserId?: number;
	IsPhoneWrong?: string;
	Use2FA: boolean;
	Success: boolean;
	ErrorMessage?: string;
}

export interface LoginViaGoogleRequest {
	AccessToken: string;
	RoleId?: number;
	ProcessId: string;
}

export interface LoginViaGoogleResponse {
	AccessToken?: string;
	TokenType?: string;
	ExpiresIn?: number;
	ProcessId?: string;
	Error?: string;
	ErrorDescription?: string;
	firstName?: string;
	lastName?: string;
	Email?: string;
	roleId?: string;
}

export const getGoogleOAuthUrl = async (): Promise<AxiosResponse<GoogleOAuthUrlResponse>> => {
	return await axiosInstance.post<GoogleOAuthUrlResponse>(
		ENDPOINTS['/api/GetGoogleOAuthUrl'],
		{},
		{ skipGenericErrorHandler: true }
	);
};

export const checkGoogleUser = async (
	accessToken: string
): Promise<AxiosResponse<CheckGoogleUserResponse>> => {
	return await axiosInstance.post<CheckGoogleUserResponse>(
		ENDPOINTS['/api/Xpress/CheckGoogleUser'],
		{ AccessToken: accessToken } as CheckGoogleUserRequest,
		{ skipGenericErrorHandler: true }
	);
};

export const loginViaGoogle = async (
	accessToken: string,
	processId: string = 'link'
): Promise<AxiosResponse<LoginViaGoogleResponse>> => {
	return await axiosInstance.post<LoginViaGoogleResponse>(
		ENDPOINTS['/api/X4bUser/LoginViaGoogle'],
		{
			AccessToken: accessToken,
			ProcessId: processId,
		} as LoginViaGoogleRequest,
		{ skipGenericErrorHandler: true }
	);
};

